module.exports = __webpack_public_path__ + "img/car_00065.fb516eb5.jpg";